import AccessibilityNewIcon from '@mui/icons-material/AccessibilityNew';
import PsychologyIcon from '@mui/icons-material/Psychology';
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import FaceRetouchingNaturalIcon from '@mui/icons-material/FaceRetouchingNatural';
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAlt';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import BackHandIcon from '@mui/icons-material/BackHand';
import HealingIcon from '@mui/icons-material/Healing';
import SelfImprovementIcon from '@mui/icons-material/SelfImprovement';
import LocalFloristIcon from '@mui/icons-material/LocalFlorist';
import SpaIcon from '@mui/icons-material/Spa';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

/**
 * Ícone de cada área de atuação. As áreas vêm do backend (SetupSegments::CATALOG);
 * aqui só o desenho. Área sem ícone usa o de "Outra área".
 */
const SEGMENT_ICONS = {
  fisioterapia: AccessibilityNewIcon,
  psicologia: PsychologyIcon,
  nutricao: RestaurantMenuIcon,
  estetica: FaceRetouchingNaturalIcon,
  odontologia: SentimentSatisfiedAltIcon,
  medicina: MedicalServicesIcon,
  osteopatia: BackHandIcon,
  quiropraxia: HealingIcon,
  pilates: SelfImprovementIcon,
  acupuntura: LocalFloristIcon,
  massoterapia: SpaIcon,
  fonoaudiologia: RecordVoiceOverIcon,
  outra: MoreHorizIcon,
};

export function segmentIcon(key) {
  return SEGMENT_ICONS[key] || MoreHorizIcon;
}
